import gql from 'graphql-tag';

export const albumCustomPrintDetails = gql`
  fragment albumCustomPrintDetails on AlbumCustomPrint {
    id
    photos_no
    display_order
    custom_print {
      id
      name
      type
      subtype
      photos_no
      preview_image {
        id
        url
      }
      description
      custom_print_caption_enabled
      card {
        id
        card_side_groups {
          records {
            id
            side
            card_sides {
              records {
                id
                card_template {
                  id
                  orientation
                  print_product {
                    id
                    print_size {
                      id
                    }
                    print_partner {
                      id
                      name
                    }
                    sizes(slice: { limit: 999 }) {
                      records {
                        id
                        sku
                        print_size {
                          id
                          name
                        }
                      }
                    }
                  }
                  print_size {
                    id
                    name
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
    }
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    album {
      id
      name
      root_album_folder {
        id
        name
      }
    }
    shipping_enabled
    shipping_required
  }
`;
